module.exports = __webpack_public_path__ + "img/logo_footer_niigata.e083d276.jpg";